import { Transition } from "@headlessui/react";
import StayCard from "components/listingcard/ListingCard";
import { Property } from "data/models/property";
import { CarDataType, ExperiencesDataType } from "data/types";
import React, { FC, Fragment } from "react";
import { useState } from "react";
import formatCurrency from "../../utils/formatCurrency";

export interface AnyReactComponentProps {
  className?: string;
  listing?: Property;
  experiences?: ExperiencesDataType;
  car?: CarDataType;
  isSelected?: boolean;
  lat: number;
  lng: number;
}

const AnyReactComponent: FC<AnyReactComponentProps> = ({
  className = "",
  listing,
  car,
  experiences,
  isSelected,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`nc-AnyReactComponent relative  ${className}`}
      data-nc-id="AnyReactComponent"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <span
        className={`flex px-2 py-1 rounded-lg text-sm font-semibold items-center justify-center min-w-max shadow-lg hover:bg-neutral-900 hover:text-white ${isSelected ? "bg-primary-green text-white" : "bg-white"
          }`}
      >
        {formatCurrency(listing?.rent) || experiences?.price || car?.price}
      </span>
      <Transition
        show={isOpen}
        as={Fragment}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="absolute z-50 bottom-full pb-3 -left-12 w-72 aspect-w-1">
          {listing && <StayCard property={listing} className="shadow-2xl" />}
        </div>
      </Transition>
    </div>
  );
};

export default AnyReactComponent;
